import React from 'react'

import FormItem from './FormItem'

class NewCommitment extends React.Component {

  renderFormItems() {
    const { availableCommitments } = this.props;

    return Object.keys(availableCommitments).map((option) => (
      <FormItem
        key={ option }
        option={ option }
        title={ availableCommitments[option].title }
        type={ availableCommitments[option].type }
        iconName={ availableCommitments[option].icon_name }
        onClick={ this.props.onNewCommitClick }
      />
    ))
  }

  render() {
    if (this.props.collapsed) {
      return(
        <div>
          <div
            className="card card-border card-btn card-add mt-3"
            id="dropdown-commitment-items"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
            data-flip="false"
          >
            <div className='media mt-1 mb-1'>
              <div className='media-body'>
                Add another commitment
              </div>
              <div className='align-self-center btn-icon'>
                <div className='material-icons'>add_circle_outline</div>
              </div>
            </div>
          </div>
          <div className="dropdown-menu" aria-labelledby="dropdown-commitment-items">
            { this.renderFormItems() }
          </div>
        </div>
      )
    } else {
      return(
        <div>
          { this.renderFormItems() }
        </div>
      )
    }
  }
}

export default NewCommitment;
